export function ensureFormUuid(existing) {
  const s = existing != null ? String(existing).trim() : "";
  if (s) return s;
  if (typeof window !== "undefined" && window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }
  return String(Date.now());
}

export function noopCreateSuccess(data) {
  return (
    Boolean(data?.success) &&
    (!data.data ||
      (typeof data.data === "object" &&
        data.data !== null &&
        !data.data._id &&
        Object.keys(data.data).length === 0))
  );
}
